import React from 'react';
import { Field, ErrorMessage } from 'formik';

import InputField from '../enhanced-input';

const FormInput = ({
  name,
  label,
  type = 'text',
  rows = '1',
  smallWidth = 'full',
  largeWidth = '3/4',
  onFocus,
  activeField,
  onBlur,
  placeholder
}: {
  name: string;
  label?: string;
  type?: string;
  rows?: string;
  smallWidth?: string;
  largeWidth?: string;
  onFocus?: (e) => void;
  activeField?: string;
  onBlur?: (e) => void;
  placeholder?: string;
}) => (
  <div className={`relative w-${smallWidth} md:w-${largeWidth} mb-5`}>
    <Field
      name={name}
      component={InputField}
      type={type}
      rows={rows}
      label={label}
      onFocus={onFocus}
      onBlur={onBlur}
      activeField={activeField}
      placeholder={placeholder}
    />
    <ErrorMessage
      name={name}
      component="div"
      className={`field-error text-red-500 text-xs mt-2 ml-3`}
      data-cy={`form-${name}-error`}
    />
  </div>
);

export default FormInput;
